module.exports = __webpack_public_path__ + "static/img/14000145.d52753df.png";